<div class=" h-100 text-center family-info" *ngIf="page == ''">
  
  <form [formGroup]="bankAccountForm" class="w-100" style="position: relative">
    <div class="ui form">
      <div class="field">
        <label>Bank Name </label>
        <select
          style="height: auto;"
          class="ui fluid search dropdown"
          name="card[expire-month]"
          formControlName="bank_code"
        >
          <option value="" selected>Providus Bank</option>
          <option
            [value]="bank?.bank_code"
            *ngFor="let bank of banks; index as i"
          >
            {{ bank?.name }}
          </option>
        </select>
        <div
          *ngIf="bankName.touched && bankName.invalid"
          class="ng-invalid ng-touched"
        >
          <small style="color: #f10b0b9d;" *ngIf="bankNameIsRequired()">
            Your Bank Name is required!</small
          >
        </div>
      </div>

      <div class="field">
        <label>Account number</label>
        <input
          (change)="checkAccountDetailsEntered()"
          type="tel"
          pattern="[0-9]{10}"
          formControlName="account_number"
          placeholder="Enter accounter number eg: 001345898"
        />
        <div
          *ngIf="accountNumber.touched && accountNumber.invalid"
          class="ng-invalid ng-touched"
        >
          <small style="color: #f10b0b9d;">
            Your account number is required and has to be 10 digits!</small
          >
        </div>
      </div>

      <div class="field">
        <label>Account name</label>
        <input
          formControlName="account_name"
          type="text"
          placeholder="eg: Chukwuka Hassan Oluwatope"
          readonly
        />
      </div>
    </div>
    <!--  (click)="page = 'info'" -->
    <div class="text-center mt-4">
      <button
        (click)="submitAccountDetailsForm(bankAccountForm)"
        type="button"
        class="ui primary button fluid"
      >
        Continue
      </button>
    </div>
    <div *ngIf="spinner" class="spinner-container">
      <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
      <app-loader></app-loader>
    </div>
  </form>
</div>

<div class=" h-100 text-center family-info" *ngIf="page == 'info'">
  <h1 class="para-title">
    We have partnered with Creditclan and Mono to analyze your transactions
  </h1>

  <div class="text-center mt-4">
    <button
      type="button"
      (click)="page = 'PIN'"
      class="ui button primary basic mt-4"
    >
      Begin
    </button>

    <button type="button" class="ui button primary basic mt-4">
      Later
    </button>
  </div>
</div>

<div class=" h-100 text-center family-info" *ngIf="page == 'PIN'">
  <h1 class="para-title">
    Enter your 4 digit pin
  </h1>

  <form [formGroup]="PINFORM" class="w-100" style="position: relative">
    <div class="ui form">
      <div class="field">
        <label>PIN</label>
        <input
          (input)="generalservice.restrictInputDigits($event, 4)"
          formControlName="PIN"
          type="text"
          placeholder="Eg: someone@someone.com"
        />
      </div>
    </div>

    <div class="text-center mt-4">
      <button
        (click)="confirmParent(PINFORM)"
        type="button"
        [disabled]="!PINFORM.valid"
        class="ui button primary basic mt-4"
      >
        Save and continue
      </button>
    </div>
    <div *ngIf="spinner" class="spinner-container">
      <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
      <app-loader></app-loader>
    </div>
  </form>
</div>

<div id="attach_card" class=" h-100 text-center family-info" *ngIf="page == 'attach-card'">
 
</div>




